import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, CreditCard, Tags, MessageSquare, Settings, Search, Bell } from 'lucide-react';
import { ViewToggle } from '../../components/portal/ViewToggle';
const navItems = [{
  name: 'Dashboard',
  path: '/portal/admin',
  icon: LayoutDashboard
}, {
  name: 'Consumers',
  path: '/portal/admin/consumers',
  icon: Users
}, {
  name: 'Communications',
  path: '/portal/admin/communications',
  icon: MessageSquare
}, {
  name: 'Settings',
  path: '/portal/admin/settings',
  icon: Settings
}];
export function AdminLayout() {
  const location = useLocation();
  return <div className="min-h-screen flex bg-gray-50 font-sans" data-id="element-926">
      {/* Left Sidebar */}
      <aside className="w-64 bg-[#1a2332] text-gray-300 flex flex-col shrink-0" data-id="element-927">
        <div className="h-16 flex items-center px-6 border-b border-gray-800 shrink-0" data-id="element-928">
          <div className="bg-white p-1 rounded shadow-sm mr-3" data-id="element-929">
            <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass" className="h-5 w-auto object-contain" data-id="element-930" />
          </div>
          <span className="text-white font-bold tracking-wide" data-id="element-931">
            Admin Portal
          </span>
        </div>

        <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto" data-id="element-932">
          {navItems.map(item => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return <Link key={item.name} to={item.path} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-brand-red text-white' : 'hover:bg-white/10 hover:text-white'}`} data-id="element-933">
                <Icon size={18} className={isActive ? 'text-white' : 'text-gray-400'} data-id="element-934" />
                {item.name}
              </Link>;
        })}
        </nav>

        <div className="p-4 border-t border-gray-800 shrink-0" data-id="element-935">
          <div className="flex items-center gap-3 px-2" data-id="element-936">
            <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-sm font-bold text-white" data-id="element-937">
              SJ
            </div>
            <div className="flex-1 min-w-0" data-id="element-938">
              <p className="text-sm font-medium text-white truncate" data-id="element-939">
                Sarah Jenkins
              </p>
              <p className="text-xs text-gray-500 truncate" data-id="element-940">Agent</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-941">
        {/* Top Bar */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-8 shrink-0" data-id="element-942">
          <div className="flex-1 max-w-xl" data-id="element-943">
            <div className="relative" data-id="element-944">
              <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-945" />
              <input type="text" placeholder="Search consumers, accounts..." className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-navy focus:bg-white transition-all" data-id="element-946" />
            </div>
          </div>
          <div className="flex items-center gap-6 ml-4" data-id="element-947">
            <ViewToggle activeView="admin" data-id="element-948" />
            <button className="relative text-gray-400 hover:text-brand-navy transition-colors" data-id="element-949">
              <Bell size={20} data-id="element-950" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-brand-red text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-white" data-id="element-951">
                7
              </span>
            </button>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto" data-id="element-952">
          <Outlet data-id="element-953" />
        </main>
      </div>
    </div>;
}